import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.TermsConditionsView.';

  public static readonly saveTermsConditions = `${Id.prefix}saveTermsConditions`;
}

export class LangTermsConditionsView {
  private constructor() {}

  public static saveTermsConditions(): string {
    return interpolate(Id.saveTermsConditions);
  }
}

export class TermsConditionsViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.saveTermsConditions,
      "Save {{glossary 'terms-conditions'}}",
      'Button label for saving terms and conditions'
    );
  }
}
